/**
 * MapPanelTabs — right-side panel tab bar for the NI & Migration Map Views.
 * Icon + label tabs with a themed active state (blue for NI, purple for Migration).
 *
 * Props:
 *  - tabs:    [{ key, label }]
 *  - active:  current tab key
 *  - onChange:(key) => void
 *  - accent:  "blue" | "purple"
 */

const ICON_PATHS = {
  layers: (
    <>
      <path d="M12 2 2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </>
  ),
  napDetails: (
    <>
      <rect x="3" y="3" width="6" height="6" rx="1" />
      <rect x="15" y="3" width="6" height="6" rx="1" />
      <rect x="3" y="15" width="6" height="6" rx="1" />
      <path d="M15 15h2v2" />
      <path d="M21 15v6h-6" />
      <path d="M18 18v.01" />
    </>
  ),
  subscriber: (
    <>
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </>
  ),
  noTeams: (
    <>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M17 8l5 5M22 8l-5 5" />
    </>
  ),
  filter: (
    <>
      <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
    </>
  ),
  details: (
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <path d="M8 13h8M8 17h8M8 9h2" />
    </>
  ),
};

export default function MapPanelTabs({ tabs, active, onChange, accent = "blue" }) {
  const activeCls =
    accent === "purple" ? "bg-purple-50 text-purple-600 shadow-sm" : "bg-blue-50 text-blue-600 shadow-sm";

  return (
    <div className="flex gap-1 p-1.5 bg-white rounded-t-lg shadow-sm border-b border-gray-200 flex-shrink-0">
      {tabs.map((t) => {
        const isActive = active === t.key;
        return (
          <button
            key={t.key}
            onClick={() => onChange(t.key)}
            className={`flex-1 flex flex-col items-center justify-center gap-1 px-1 py-1.5 rounded-md text-[9.5px] font-bold uppercase tracking-wide leading-tight text-center transition-all ${
              isActive ? activeCls : "text-gray-400 hover:text-gray-600 hover:bg-gray-50"
            }`}
          >
            <svg
              className="w-[18px] h-[18px]"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              viewBox="0 0 24 24"
            >
              {ICON_PATHS[t.key]}
            </svg>
            <span>{t.label}</span>
          </button>
        );
      })}
    </div>
  );
}
